"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulationPaymentValidation = void 0;
const PaymentTerminalControlPaymentPresentedMethodValidation_1 = require("./PaymentTerminalControlPaymentPresentedMethodValidation");
class SimulationPaymentValidation {
    static isValid(entity) {
        // If entity.membership_id exists, validate that it has the correct type.
        if (entity.membership_id != undefined) {
            if (typeof entity.membership_id !== "string")
                return false;
        }
        // Validate entity.payment_method for existence and correct type.
        if (entity.payment_method == undefined)
            return false;
        if (!PaymentTerminalControlPaymentPresentedMethodValidation_1.PaymentTerminalControlPaymentPresentedMethodValidation.isValid(entity.payment_method))
            return false;
        // If entity.card_bin exists, validate that it has the correct type.
        if (entity.card_bin != undefined) {
            if (typeof entity.card_bin !== "string")
                return false;
        }
        // If entity.masked_track_2_data exists, validate that it has the correct type.
        if (entity.masked_track_2_data != undefined) {
            if (typeof entity.masked_track_2_data !== "string")
                return false;
        }
        // If entity.is_rfid exists, validate that it has the correct type.
        if (entity.is_rfid != undefined) {
            if (typeof entity.is_rfid !== "boolean")
                return false;
        }
        return true;
    }
}
exports.SimulationPaymentValidation = SimulationPaymentValidation;
